import {BaseProps} from "../../../infrastructure/models/props/base-props";
import classNames from 'classnames';

import React, {forwardRef} from 'react';

export class TableProps extends BaseProps {
  className: String;
}

export const Table = forwardRef(({className, children}: TableProps, ref) => {
  return (
    <table className={classNames(className, 'table')} ref={ref}>
      <tbody>
      {
        children
      }
      </tbody>
    </table>
  )
});
